import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-688 (4.3 phone).
export const PhoneScreen = () => (
  <StubScreen id="phone" heading="Ihre Telefonnummer" />
);
